export const GetAllProjectsWithSearchText = `
query GetAllProjectsWithSearchText(
    $tags: [Int],
    $careerIds: [Int],
    $traits:[String]
    $uids: [Int],
    $page: Int,
    $perpage: Int
    $search: String,
    $orderby: OrderByEnum,
    $postTypeId: Int,
    $workspaceIds: [Int]
){
    Courses(tags: $tags, careerIds: $careerIds, page: $page, perpage: $perpage, uids: $uids, traits: $traits, search: $search, orderby: $orderby, postTypeId: $postTypeId, workspaceIds: $workspaceIds){
      items {
            workspace {
            name,
            id
            }
            creatoruid
            postid
            dateupdated
            postthumbnail
            published
            active
            title
            postmobilecover
            postthumbnailcover
            contenttime
            product {
              productid
              active

              prices {
                  productpriceid
                  price
              }

              discountcoupons {
                  couponcode
              }
          }
            creator {
                profilepicture
                occupationtitle,
                uid,
                alias
                relatedmedia {
                    render
                    mediacontenttype {
                        internalname
                    }
                    imagesettings {
                        width
                        height
                        waspectratio
                        haspectratio
                        xcenter
                        ycenter
                    }
                }
            }

            tags {
                tagid
                name
                tagtype {
                    internalname
                }
            }

            traits {
                name
                internalname
            }

        }
        totalCount
        perpage
        page
    }
  }
`;
